import axios from "../../infra/http/axios/axios";

export const OverviewApi = {
    getDailyOverview: () => axios.get(`/api/doctor/overview/daily`),

    getMonthlyOverview: () => axios.get(`/api/doctor/overview/monthly`)
};
